import '@/common';
import {JSONParser} from "@/utils/JSONParser";
import {ModalData} from "@/widgets/FeedbackWidget/types";
import {feedbackWidget} from "@/common/widgets";
import { createCatalogWidget } from '@/widgets/CatalogWidget';

createCatalogWidget(document.querySelector('#catalog-widget')!);

window.addEventListener('favoritesChange', () => {
    if (window.$favorites.count === 0) {
        document.querySelector('#favorites-list')?.classList.add('favorites-list--empty');
    }
});
[...document.querySelectorAll('.js-feedback-widget')].forEach((el) => {
    el.addEventListener('click', () => {
        const parser = new JSONParser('js-feedback-widget-parser');
        const action = el.getAttribute('data-action');
        const rawModalData = parser.parse<ModalData>(el.getAttribute('data-modal'));

        switch (action) {
            default:

                const trailer = Object.assign({}, rawModalData.trailer, {});

                const modalData = Object.assign({}, rawModalData, {
                    trailer,
                });

                feedbackWidget.show(modalData);
                break;
        }
    });
});
